import React, { useEffect, useState } from "react";
import { TransactionDTO } from "../transactions-list/type";
import { Spinner } from "react-bootstrap";
import moment, { Moment } from "moment-jalaali";
import { UseQueryResult } from "react-query";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
  TimeScale,
  LineController,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import "chartjs-adapter-moment";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  LineController
);

interface TransactionsLineChartProp {
  transactions?: {
    terminalId?: number | undefined;
    query: UseQueryResult<TransactionDTO, unknown>;
  }[];
  isLoading?: boolean;
  startDate: string;
  endDate: string;
}

export const TransactionsLineChart: React.FC<TransactionsLineChartProp> = ({
  transactions,
  isLoading,
  startDate,
  endDate,
}) => {
  const [chartData, setChartData] = useState<
    ChartData<"line", { x: string; y: number }[]>
  >({
    datasets: [],
  });
  useEffect(() => {
    let temp: ChartData<"line", { x: string; y: number }[]> = {
      datasets: [],
    };
    transactions?.forEach((transaction, index) => {
      if (transaction.query.data?.data) {
        const successTransactions = transaction.query.data.data
          .filter(
            ({ status, responseCode }) =>
              status === "220" && responseCode === "00"
          )
          .sort((a, b) => moment(a.date_2).diff(moment(b.date_2)));
        let accumulatedAmount = 0;
        const newTransactions = successTransactions.map((transaction) => {
          if (
            transaction.responseCode === "00" &&
            transaction.status === "220"
          ) {
            accumulatedAmount += transaction.amount;
          }

          return {
            ...transaction,
            accumulatedAmount: accumulatedAmount,
          };
        });
        const formattedData = newTransactions.map((item) => {
          return {
            x: item.date_2,
            y: item?.accumulatedAmount,
          };
        });
        temp.datasets.push({
          label: `درگاه ${transaction.terminalId}`, // Label for each terminal
          data: formattedData || [],
          borderColor: `rgba(${255 - index * 30}, 99, 132, 1)`, // Dynamic color
          backgroundColor: `rgba(${255 - index * 30}, 99, 132, 0.5)`,
        });
      }
    });
    setChartData(temp);
  }, [transactions]);
  const minTime = 946672200000; // Example start time
  const maxTime = 1729695424000; // Example end time
  const timeRange = (maxTime - minTime) / (1000 * 60 * 60); // Calculate time range in hours

  const stepSize = timeRange > 1000 ? 24 : 1; // Use 24-hour steps if the range is large

  return (
    <Chart
      type="line"
      data={chartData}
      options={{
        animation: {
          duration: 0,
        },

        plugins: {
          legend: {
            labels: {
              font: {
                family: "shabnam",
                size: 14,
                weight: "bold",
              },
            },
          },
          tooltip: {
            callbacks: {
              title: (items) => {
                return items
                  .map((item, index) =>
                    //@ts-ignore
                    moment(item.raw.x).format(
                      `HH:mm:ss jYYYY-jMM-jDD  ( ${index + 1} `
                    )
                  )
                  .join(`\n`);
              },
            },
            titleFont: {
              family: "shabnam",
              size: 15,
            },
            bodyFont: {
              family: "shabnam",
              size: 14,
            },
          },
          title: {
            display: true,
            text: "تراکنش های موفق امروز",
            font: {
              family: "shabnam",
              size: 18,
              weight: "bold",
            },
          },
        },
        scales: {
          x: {
            min: moment(startDate).format("YYYY-MM-DD 00:00:00"),
            max: moment(startDate).format("YYYY-MM-DD 23:59:59"),

            type: "time",
            time: {
              unit: "hour",
              displayFormats: {
                hour: "HH",
              },
            },
            ticks: {
              font: {
                family: "shabnam",
                size: 14,
                weight: "bold",
              },
            },
          },
          y: {
            title: {
              display: true,
              text: " مبلغ (ریال)",
              font: {
                family: "shabnam",
                size: 14,
                weight: "bold",
              },
            },
            ticks: chartData.datasets.some((item) => item.data?.length)
              ? {
                  font: {
                    family: "shabnam",
                    size: 14,
                    weight: "bold",
                  },
                }
              : {
                  display: false,
                },
          },
        },
      }}
    />
  );
};
